import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { CallProvider } from './callContext/callContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { MainProvider } from './callContext/MainContext';
import { syncCampaignFromUrl } from './utils/Helpers';
syncCampaignFromUrl();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="295869428599-gdhvgls4aai9307j2vp7qakq324rgpsj.apps.googleusercontent.com">
    <CallProvider>
      <MainProvider>
    <Router>
    <App />
    </Router>
      </MainProvider>
    </CallProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
